import { updateFolderIdsIfNeeded } from '../actions/internalActions';
import { getSelectedCalendars } from '../selectors/dayGridSelectors';
import getScenarioStore from '../selectors/getScenarioStore';
import { observer } from 'mobx-react';
import { calendarIsInCache } from 'owa-calendar-cache';
import { getCalendarEventColorScheme, getDefaultColorSchemes } from 'owa-calendar-color-resolver';
import { getCharm } from 'owa-calendar-events-store';
import { ClientItemId } from 'owa-client-ids';
import { DayGridScenario } from 'owa-day-grid';
import React from 'react';
import {
    createSchedulingConfig,
    isAttandeeItem,
    isSchedulingSelectionItem,
    SchedulingGrid,
    SchedulingGridScrollBehavior,
} from 'owa-calendar-scheduling-grid';
import {
    AutoScrollBehavior,
    inDayItemTemplate,
    ScrollToWorkingHoursBehavior,
    TimeMarkerTodayBehavior,
} from 'owa-calendar-surface-dategrid';

const styles = require('./DayGridView.scss');
const classNames = require('classnames/bind').bind(styles);

export interface DayGridViewProps {
    scenario: DayGridScenario;
    selectedEventId?: ClientItemId;
}

@observer
export default class DayGridView extends React.Component<DayGridViewProps> {
    render() {
        const { scenario } = this.props;
        const store = getScenarioStore(scenario);
        if (!store || !store.schedulingGridViewState) {
            return null;
        }

        return (
            <DayGridViewInternal
                calendarIds={getSelectedCalendars().filter(calendarIsInCache)}
                {...this.props}
            />
        );
    }
}

interface DayGridViewInternalProps extends DayGridViewProps {
    calendarIds: string[];
}

@observer
class DayGridViewInternal extends React.Component<DayGridViewInternalProps> {
    constructor(props: DayGridViewInternalProps) {
        super(props);
        updateFolderIdsIfNeeded(props.scenario, props.calendarIds);
    }

    componentDidUpdate(prevProps: DayGridViewInternalProps) {
        const { scenario, calendarIds } = this.props;
        if (prevProps.calendarIds !== calendarIds) {
            updateFolderIdsIfNeeded(scenario, calendarIds);
        }
    }

    render() {
        const { scenario, selectedEventId } = this.props;
        const viewState = getScenarioStore(scenario).schedulingGridViewState;

        const config = {
            ...createSchedulingConfig(viewState),
            getItemConfig: () => ({
                itemsEventHandlers: null,
                itemsDecorator: item => (
                    <div
                        className={classNames(styles.gridItem, {
                            itemSelected: selectedEventId && item.ItemId.Id == selectedEventId.Id,
                        })}
                        id={item.ItemId.Id}
                    />
                ),
                template: (store, model, state) =>
                    isAttandeeItem(model) || isSchedulingSelectionItem(model)
                        ? null
                        : inDayItemTemplate(
                              store,
                              model,
                              model.ParentFolderId
                                  ? getCalendarEventColorScheme(model)
                                  : getDefaultColorSchemes()[0],
                              model.ParentFolderId ? getCharm(model) : null,
                              state
                          ),
            }),
        };

        return (
            <SchedulingGrid
                store={viewState}
                config={config}
                inDayBehaviors={[
                    <TimeMarkerTodayBehavior columnProvider={config.columnProvider} />,
                    <AutoScrollBehavior />,
                    <ScrollToWorkingHoursBehavior store={viewState} />,
                    <SchedulingGridScrollBehavior viewState={viewState} />,
                ]}
            />
        );
    }
}
